import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers/internalApi";
import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import { flatten } from "lodash";
import { useEffect } from "react";
import { useInfiniteQuery } from "react-query";

export const useCommunityInboxSearch = (searchQuery: string) => {
  const { setChats } = useCommunityInboxStore();

  const fetchChats = (page: number) =>
    reactQueryGet(
      internalApi.search.communityInbox.chats({
        params: {
          page,
          query: searchQuery,
        },
      }),
    );

  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ["community-inbox-search", searchQuery],
    queryFn: ({ pageParam = 1 }) => fetchChats(pageParam),
    enabled: searchQuery.length > 0,
    getNextPageParam: lastPage =>
      lastPage.has_next_page ? lastPage.page + 1 : undefined,
    select: ({ pages = [] }) => ({
      pages: flatten(pages.map(page => page.records)),
      pageParams: pages.map(page => page.page),
      pagesList: pages,
    }),
  });

  useEffect(() => {
    setChats(data?.pages || [], "admin");
  }, [data, setChats]);

  return {
    fetchNextPage,
    hasNextPage,
    isLoading: isFetching,
  };
};
